import {
  MenuItem as MUIMenuItem,
  dividerClasses,
  listItemIconClasses,
} from '@mui/material';
import { styled } from '@mui/material/styles';

export const MenuItem = styled(MUIMenuItem)(({ theme }) => ({
  fontSize: '14px',
  padding: `${theme.spacing(1)} ${theme.spacing(1.5)}`,
  height: 36,

  [`+.${dividerClasses.root}`]: {
    margin: 0,
  },

  [`& .${listItemIconClasses.root}`]: {
    minWidth: 24,
    marginRight: theme.spacing(1),
  },
})) as typeof MUIMenuItem;
